<template>
  <div class="checkout-steps-wrap">
    <div class="checkout-steps">
      <div
        class="checkout-step"
        :class="{
          visited: step >= 3,
          selected: step === 3,
        }">
        <span class="checkout-step-done"><i class="fa-solid fa-circle-check"></i></span>
        <span class="checkout-step-number">1</span>
        <span class="checkout-step-title">{{ t('checkout.header.delivery') }}</span>
      </div>
      <div
        class="checkout-step"
        :class="{
          visited: step >= 4,

          selected: step === 4,
        }">
        <span class="checkout-step-done"><i class="fa-solid fa-circle-check"></i></span>
        <span class="checkout-step-number">2</span>
        <span class="checkout-step-title">{{ t('checkout.header.payment') }}</span>
      </div>

      <div
        class="checkout-step"
        :class="{
          visited: step >= 5,
          selected: step === 5,
        }">
        <span class="checkout-step-done"><i class="fa-solid fa-circle-check"></i></span>
        <span class="checkout-step-number">3</span>
        <span class="checkout-step-title">{{ t('checkout.header.confirmation') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useCheckoutStore } from '~/store/checkout'
import { useLang } from '~/composables/useLang'

const { t } = useLang()
const checkoutStore = useCheckoutStore()

const step = computed(() => checkoutStore.step)
</script>

<style lang="postcss" scoped>
.checkout-steps-wrap {
  @apply rounded-md overflow-hidden w-min border border-neutral5;

  .checkout-steps {
    @apply flex items-center bg-white dark:bg-dmGray1 rounded-md;

    .checkout-step {
      @apply flex items-center gap-2 text-xs text-gray0 dark:text-dmText3 h-[40px] relative px-5;

      &::before {
        @apply absolute w-3 h-16 lg:w-6 lg:h-[40px] top-0 left-0;

        content: url('/assets/icons/checkout-arrow-white.png');
        top: 0;
        left: 0;
        z-index: 1;
      }

      &:first-of-type {
        &::before {
          display: none;
        }
      }

      &:last-of-type {
        @apply rounded-tr-[4px];
      }

      .checkout-step-number {
        @apply flex items-center justify-center rounded-full border-solid h-[1.5rem] w-[1.5rem] bg-gray1 dark:bg-dmGray1 font-medium;
      }
      .checkout-step-title {
        @apply hidden xl:flex;
      }
      .checkout-step-done {
        @apply hidden text-[1.5rem] leading-none;
      }

      &.selected {
        @apply !text-red bg-brand-bgLight;

        .checkout-step-number {
          @apply bg-red text-white dark:text-black;
        }

        .checkout-step-title {
          @apply flex;
        }

        &::before {
          content: url('/assets/icons/checkout-arrow-white.png') !important;
        }

        & + :not(.selected)::before {
          content: url('/assets/icons/checkout-arrow-blue.png');
        }
      }
    }
    .checkout-step-arrow {
      @apply text-neutral3 dark:text-dmText3 text-xs;
    }
  }
}

.wl .checkout-steps-wrap {
  @apply border-none bg-gray1 dark:bg-dmGray1;

  .checkout-steps {
    @apply bg-gray1 dark:bg-dmGray1 gap-1;
  }

  .checkout-step {
    @apply flex items-center gap-2 text-xs text-gray0 dark:text-dmText3 h-[40px] relative px-5 rounded-md bg-gray1 dark:bg-dmGray1;

    &::before {
      content: none !important;
    }

    .checkout-step-number {
      @apply flex
      items-center
      justify-center
      rounded-sm
      h-[1.5rem]
      w-[1.5rem]
      bg-white
      font-semibold;
    }

    &.selected,
    &.visited {
      @apply bg-brand-primary;

      .checkout-step-number {
        @apply bg-white dark:bg-dmGray1 text-brand-primary font-black;
      }

      .checkout-step-title {
        @apply text-white font-semibold;
      }

      &::before {
        content: none !important;
      }
    }
  }
}
</style>
